/* global NeonPlayerSilverlight */
/* global NeonPlayerDash */
/* global NeonPlayerUtils */
/* global define */

(function(window, document, undefined) {
	"use strict";

	/*
		* Global api.
		*/
	var neonPlayer = {
		get: function() {
			return _instance;
		},
		//Main entry point.
		init: function(options, callback) {
			return _instance || new NeonPlayer(options, callback);
		},
		getSettings: function() {
			return _settings;
		}
	};


	/*
		Private methods and variables
	*/

	//Singleton
	var _instance;

	var _container = undefined;
	var _videoPlayer = undefined;
	var _stateEnum = {
		CLOSED: "closed",
		INITIALIZED: "initialized",
		PLAYING: "playing"
	};
	var _state = _stateEnum.CLOSED;
	var _settings = {
		debug: true
	};

	var _containertag = function () {
		return "#" + _container;
	};

	var _setState = function (state) {
		_state = state;
		$(document).trigger("stateChangeEvent", {sender: "wrapper", detail: _state});
	};


	/**
	 * Constructor
	 */
	function NeonPlayer(options, callback) {
		try {
			
			_instance = this;
			
			// Set settings based on input and defaults
			_settings = $.extend({
				id: "playerContainer",
				width: "840",
				height: "484",
				eventListener: function() {},
				widevineLicenserUrl: "https://rightsmanager.sfanytime.com/rightsmanager/WidevineLicenser.svc", // PROD
				smoothLicenserUrl: "https://rightsmanager.sfanytime.com/rightsmanager/PlayReadyLicenser.asmx", // PROD
				language: "",
				debug: false,
				skin: "sfa"
			}, options);
			
			_container = _settings.id;
			
			if (_state >= _stateEnum.INITIALIZED) {
				console.warn("Player element is already initialized.");
				return;
			}

			if (_container.indexOf("#") > -1 ) {
				console.error("playerContainer cannot contain '#'");
				return;
			}
			
			if (!$(_containertag()).is("div")) {
				console.error("playerContainer must be a div");
				return;
			}
			
			$(_containertag()).addClass("vjs-hidden");
			
			// Call post-init callback
			typeof callback === "function" && callback();
			
			return _instance;
			
		} catch (error) {
			console.error("errorEvent when creating player object: " + error);
			$(document).trigger("errorEvent", {sender: "NeonPlayer.init", detail: error});
		}
	}


	// Public methods

	// Loads video based on the playbackArguments and starts playback
	NeonPlayer.prototype.start = function (playbackArguments) {
		try {
			var playbackSettings = $.extend({
				customerToken: "",
				deviceToken: "",
				videoTitle: "",
				encrypted: false
			}, playbackArguments);
			
			var internalPlayer = NeonPlayerUtils.chooseInternalPlayer(playbackArguments.encrypted);
			switch (internalPlayer) {
			case NeonPlayerUtils.getLiterals().html5:
				_videoPlayer = new NeonPlayerDash();
				break;
			case NeonPlayerUtils.getLiterals().silverlight:
				_videoPlayer = new NeonPlayerSilverlight(_settings.debug);
				break;
			default:
				throw "Unsupported playback";
			}
			_videoPlayer.createPlayer(document.querySelector(_containertag()), _settings);
			_setState(_stateEnum.INITIALIZED);
			
			// Set Listeneners
			$(document).unbind("playbackEvent", _settings.eventListener);
			$(document).bind("playbackEvent", _settings.eventListener);
			
			$(document).unbind("fullscreenEvent", _settings.eventListener);
			$(document).bind("fullscreenEvent", _settings.eventListener);		
			
			$(document).unbind("errorEvent", _settings.eventListener);
			$(document).bind("errorEvent", _settings.eventListener);
			
			$(document).unbind("closeEvent", _settings.eventListener);
			$(document).bind("closeEvent", _settings.eventListener);
			
			$(document).unbind("closingEvent", _instance.close);
			$(document).bind("closingEvent", _instance.close);
			
			// Set initial seeking, if needed 
			var initialSeek = function(sender, event) {
				if(event.detail == "playing") {
					console.warn("start time seeking to " + playbackSettings.startTime);
					_videoPlayer.seek(playbackSettings.startTime);
					$(document).unbind("playbackEvent", initialSeek);
				}
			};
			if(playbackSettings.startTime) {
				$(document).bind("playbackEvent", initialSeek);
			}
						
			if (_state == _stateEnum.CLOSED) {
				console.warn("Cannot start playback without initilizing the the player first.");
				return;
			}
			if (_state == _stateEnum.PLAYING) {
				console.warn("Playback already started.");
				return;
			}

			$(_containertag()).removeClass("vjs-hidden");
			
			// Start playback
			_videoPlayer.startPlayback(playbackSettings);
			_setState(_stateEnum.PLAYING);
			
		} catch (error) {
			console.error("errorEvent when starting playback: " + error);
			$(document).trigger("errorEvent", {sender: "NeonPlayer.start", detail: error});
		}
	};

	// Determines whether playback is possible, and with what technology, given the current context (technologies supported by browser, state of server-side services, etc)
	NeonPlayer.prototype.checkIfPlayabe = function(dashManifest, callback) {
		NeonPlayerUtils.checkIfPlayabe(dashManifest, _settings.dashLicenserUrl, callback);
	};

	// Plays or resumes playback of current video
	NeonPlayer.prototype.play = function () {
		if (_state != _stateEnum.PLAYING) {
			console.warn("Player element is not currently playing.");
			return;
		}
		_videoPlayer.play();
	};

	// Pause playback of current video
	NeonPlayer.prototype.pause = function () {
		if (_state != _stateEnum.PLAYING) {
			console.warn("Player element is not currently playing.");
			return;
		}
		_videoPlayer.pause();
	};

	// Unloads the current video (if any), disposes the player object and removes markup in page
	NeonPlayer.prototype.close = function () {
		if (_state == _stateEnum.CLOSED) {
			console.warn("Cannot close player element when not currently playing.");
			return;
		}
		_videoPlayer.close();
		_setState(_stateEnum.CLOSED);

		$("#" + _container).empty();
		
		_instance = undefined;
		_container = undefined;
		
		// Trigger close event
		$(document).trigger("closeEvent", {sender: "sfa-player.js", detail: "ended"});
	};

	NeonPlayer.prototype.getState = function () {
		return _state;
	};

	NeonPlayer.prototype.seek = function (seconds) {
		_videoPlayer.seek(seconds);
	};

	NeonPlayer.prototype.getCurrentTime = function () {
		return _videoPlayer.getCurrentTime();
	};

	NeonPlayer.prototype.getDuration = function() {
		return _videoPlayer.getDuration();
	};

	//Expose neonPlayer as either a global variable or a require.js module.
	if(typeof define === "function" && define.amd) {
		define([], function () {
			return neonPlayer;
		});
	} else if (typeof module !== "undefined" && module.exports) {
		module.exports = neonPlayer;
	} else {
		window.neonPlayer = neonPlayer;
	}

}(window, document));